<template>
<div>

  <!-- mobile nav menu -->
	<nav :class="[{ open:mobileNav }, 'nav-y dropdown hidden-sm hidden-md hidden-lg hidden-xl']">
		<ul class="text-center pad-t-20">
			<li><a :href="siteUrl+'/about'">About</a></li>
	        <li><a :href="siteUrl+'/how-it-works'">How It Works</a></li>
          <li><a :href="siteUrl+'/why-us'">Why Us?</a></li>
	        <li><a :href="siteUrl+'/faq'">FAQ</a></li>
	        <li><a :href="siteUrl+'/hours-location'">Hours & Location</a></li>
	        <!-- <a :href="siteUrl+'/get-cash-offer'" class="sm-btn iblock color-blue bg-white">GET CASH OFFER</a> -->
		</ul>
	</nav>
  
<header class="page-header">

		<nav role="navigation" class="main-nav hidden-xs">
	        <div id="menuToggle">
	          	<input type="checkbox" />
	            <span></span>
	            <span></span>
	            <span></span>
		        <ul id="menu">
		          <!-- <li><a :href="siteUrl+'/get-cash-offer'">Get Cash Offer</a></li> -->
		          <li><a :href="siteUrl+'/about'">About</a></li>
		          <li><a :href="siteUrl+'/how-it-works'">How It Works</a></li>
		          <li><a :href="siteUrl+'/why-us'">Why Us</a></li>
		          <li><a :href="siteUrl+'/faq'">FAQ</a></li>
		          <li><a :href="siteUrl+'/hours-location'">Hours & Location</a></li>
		        </ul>
	       </div>
	    </nav>

    <!-- MOBILE NAV BUTTON -->
		<button type="button" @click="mobileNav = !mobileNav" class="mobile-nav-toggle hidden-sm hidden-md hidden-lg hidden-xl">
			<span class="burger"></span>
			<span class="burger"></span>
			<span class="burger"></span>
		</button>

	    
		<div class="site-logo text-center pad-t-50 hidden-xs">
		    <a href="/" class="iblock"><img style="width:248px;height:auto;" src="../assets/images/logo.png"></a>
		</div>
		<div class="site-logo-xs pad-l-15 pad-t-15 hidden-sm hidden-md hidden-lg hidden-xl">
		    <a href="/" class="iblock"><img style="width:170px;height:auto;" src="../assets/images/logo-clean.jpg"></a>
		</div>
	</header>


</div>
</template>

<script>
export default {
    data() {
        return {
            siteUrl: 'http://m4c.webeatweb.com',
            mobileNav: false,
            open: 'open'
        }
    }
}
</script>


<style>

nav.main-nav {
	position: absolute;
	left: 50px;
	top: 50px;
  background-color: #222;
  height: 52px;
  width: 52px;
  border-radius: 52px;
  display: inline-block;
}


nav.main-nav.nav-xs {
	left: auto;
	right: 15px;
	top: 15px;
	height: 40px;
	width: 40px;

}


#menuToggle {
  display: flex;
  flex-direction: column;
  position: relative;
  top: 16px;
  left: 13px;
  z-index: 1;
  -webkit-user-select: none;
  user-select: none;
}

nav.main-nav.nav-xs #menuToggle {
	left: auto;
	right: 15px;
}

#menuToggle input {
  display: flex;
  width: 40px;
  height: 32px;
  position: absolute;
  cursor: pointer;
  opacity: 0;
  z-index: 2;
  
}

#menuToggle span {
  display: flex;
  width: 25px;
  height: 3px;
  margin-bottom: 5px;
  position: relative;
  background: #ffffff;
  border-radius: 3px;
  z-index: 1;
  transform-origin: 0px 2px;
  transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
              background 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
              opacity 0.55s ease;
}

#menuToggle span:first-child
{
  transform-origin: 0% 0%;
}

#menuToggle span:nth-last-child(2) {
  transform-origin: 0% 100%;
}

#menuToggle input:checked ~ span {
  opacity: 1;
  transform: rotate(45deg) translate(-3px, -1px);
  background: #FFF;
}
#menuToggle input:checked ~ span:nth-last-child(3) {
  opacity: 0;
  transform: rotate(0deg) scale(0.2, 0.2);
}

#menuToggle input:checked ~ span:nth-last-child(2) {
  transform: rotate(-45deg) translate(0, -1px);
}

#menu {
	position: absolute;
	left: 0;
	top: 0;
    width: 360px;
    height: 600px;
    box-shadow: 0 0 10px #85888C;
    margin: -70px 0 0 -65px;
    padding: 120px 60px 0 60px;
    
    background-color: #1EA0D9;
    color: white;
  -webkit-font-smoothing: antialiased;
  transform-origin: 0% 0%;
  transform: translate(-100%, 0);
  transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0);
}

nav.main-nav.nav-xs #menu {
	
	height: 600px;
	width:100%;
	transform: translate(0, 0);
}

#menu li {
  padding: 10px 0;
  transition-delay: 2s;
  font-size: 26px;
  font-weight: bold;
}

#menuToggle input:checked ~ ul {
  transform: none;

}

nav.main-nav.nav-xs #menuToggle input:checked ~ ul {

height: 600px;
}



.nav-y{
	position: absolute;
	right:0;
	top:0;
	z-index: 100;
}


.nav-y.dropdown{
	position: fixed;
	width: 100%;
	padding-top: 64px;
	height: 0;
	transition: height 0.5s;
		-webkit-transition: height 0.5s;

	overflow: hidden;
	background: rgba(255, 255, 255, 0.95);
}

.nav-y.dropdown ul > li{
	font-weight: 400;
	font-size: 18px;
	line-height: 18px;
	margin-bottom: 25px;
	text-transform: uppercase;
}

.nav-y.dropdown.open{
	height: 100%;
}

.mobile-nav-toggle{
	position: fixed;
	z-index:102;
	right: 20px;
	top: 15px;
	
	background: #222;
	color: white;
	width: 32px;
	height: 32px;
	border-radius: 32px;
  display: flex;
  flex-direction: column;
	justify-content: center;
	align-items: center;
}

.mobile-nav-toggle:hover{
	cursor: pointer;
}

.mobile-nav-toggle .burger{
	display: block;
	width: 18px;
	  height: 2px;
	  margin: 2px 0;
	  position: relative;
	  background: #ffffff;
	  border-radius: 3px;
}




.site-logo-xs{
  position:fixed;
	z-index: 101;
	width: 100%;
	padding-bottom: 8px;
	box-shadow: 0 0 10px rgba(0,0,0,0.1);
}


</style>